import React, { useState, useEffect } from "react";
import Layout from "../Layout/Layout";
import GoalsOverviewBox from "../Components/GoalsOverviewBox";
import { toast } from "react-toastify";
import { useGetGoalsOverview } from "../Controllers/GoalsAndTargetController";
import BaseModal from "../Components/Modals/BaseModal";
import { TargetReflectionModal } from "../Components/GoalsAndTargets/TargetReflectionModal";

export default function GoalsOverview() {
  const [year, setYear] = useState(new Date().getFullYear());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedGoal, setSelectedGoal] = useState(null);

  const {
    data: overviewData,
    isLoading: loadingGoalsOverview,
    error,
  } = useGetGoalsOverview({ year });

  const goalsOverview = overviewData?.goal_overview;

  useEffect(() => {
    if (error) {
      toast.error(error.message || "Failed to fetch goals overview");
      console.error("Failed to fetch goals overview", error);
    }
  }, [error]);

  const handleNextClick = () => {
    setYear((prevYear) => prevYear + 1);
  };

  const handlePrevClick = () => {
    setYear((prevYear) => prevYear - 1);
  };

  const handleGoalClick = (goalData) => {
    if (!goalData.userGoalId) {
      toast.info("No targets or reflections available for this goal");
      return;
    }

    setSelectedGoal(goalData);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedGoal(null);
  };

  return (
    <Layout>
      <div className="page-content">
        <div className="assessment-content">
          <div className="d-flex gap-3 mb-3 mb-md-4 align-items-center">
            <img
              style={{ cursor: "pointer" }}
              src="/icons/back-arrow.svg"
              onClick={() => (window.location.href = "goals-and-targets")}
            />
            <h1 className="text-heading-h2 mb-0" style={{ color: "#e6ecf1" }}>
              Goals Overview
            </h1>
          </div>
          <div className="goals-overview-container">
            {loadingGoalsOverview ? (
              <div className="text-center py-5">
                <div className="loader-container">
                  <div className="loader"></div>
                </div>
              </div>
            ) : (
              <>
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ gap: "12px", marginBottom: "32px" }}
                >
                  <button
                    id="prevButton"
                    className="btn d-flex justify-content-center align-items-center rounded-circle"
                    onClick={handlePrevClick}
                    style={{
                      backgroundColor: "#1c2934",
                      width: "40px",
                      height: "40px",
                    }}
                  >
                    <img src="/icons/pagination-left-icon.svg" alt="" />
                  </button>
                  <ul className="nav nav-tabs goals-overview-tabs  gap-0 mb-0">
                    <li className="nav-item">
                      <a
                        className="nav-link text-body-b1 active"
                        data-bs-toggle="tab"
                        aria-current="page"
                        data-bs-target="#q1"
                      >
                        Q1-{year}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link text-body-b1"
                        data-bs-toggle="tab"
                        data-bs-target="#q2"
                      >
                        Q2-{year}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link text-body-b1"
                        data-bs-toggle="tab"
                        data-bs-target="#q3"
                      >
                        Q3-{year}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link text-body-b1"
                        data-bs-toggle="tab"
                        data-bs-target="#q4"
                      >
                        Q4-{year}
                      </a>
                    </li>
                  </ul>
                  <button
                    id="nextButton"
                    className="btn d-flex justify-content-center align-items-center rounded-circle"
                    onClick={handleNextClick}
                    style={{
                      backgroundColor: "#1c2934",
                      width: "40px",
                      height: "40px",
                    }}
                  >
                    <img src="/icons/pagination-right-icon.svg" alt="" />
                  </button>
                </div>

                <div className="tab-content assessment-tab-content">
                  <div id="q1" className="tab-pane fade show active">
                    <div className="d-flex flex-column align-items-center">
                      <h1
                        className="text-heading-h3"
                        style={{ color: "#e6ecf1", marginBottom: "32px" }}
                      >
                        Monthly Missions
                      </h1>
                      <div
                        className="goals-overview-cards-container"
                        style={{ marginBottom: "32px" }}
                      >
                        {goalsOverview?.Q1?.months?.map((detail, index) => (
                          <GoalsOverviewBox
                            key={index}
                            title={["January", "February", "March"][index]}
                            headings={Object.entries(detail).map(
                              ([key, value]) => ({
                                title: key,
                                selected: value,
                                userGoalId:
                                  goalsOverview?.Q1?.months_user_goal_ids?.[
                                    index
                                  ]?.[key] || null,
                                time_period: "monthly",
                                month: ["January", "February", "March"][index],
                                quarter: "Q1",
                              }),
                            )}
                            onGoalClick={handleGoalClick}
                          />
                        ))}
                      </div>
                      <h1
                        className="text-heading-h3"
                        style={{ color: "#e6ecf1", marginBottom: "32px" }}
                      >
                        Quarterly Facts & Yearly Targets
                      </h1>
                      <div className="goals-overview-cards-container for-facts-and-targets">
                        {goalsOverview?.Q1?.quarterly_goals && (
                          <GoalsOverviewBox
                            title="Fact Assessments"
                            headings={Object.entries(
                              goalsOverview.Q1.quarterly_goals,
                            ).map(([key, value]) => ({
                              title: key,
                              selected: value,
                              userGoalId:
                                goalsOverview?.Q1?.quarterly_user_goal_ids?.[
                                  key
                                ] || null,
                              time_period: "quarterly",
                              quarter: "Q1",
                            }))}
                            onGoalClick={handleGoalClick}
                          />
                        )}
                        {goalsOverview?.yearly_goals && (
                          <GoalsOverviewBox
                            title="Yearly Targets"
                            headings={Object.entries(
                              goalsOverview.yearly_goals,
                            ).map(([key, value]) => ({
                              title: key,
                              selected: value,
                              userGoalId:
                                goalsOverview?.yearly_user_goal_ids?.[key] ||
                                null,
                              time_period: "yearly",
                              year: year,
                            }))}
                            onGoalClick={handleGoalClick}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div id="q2" className="tab-pane fade">
                    <div className="d-flex flex-column align-items-center">
                      <h1
                        className="text-heading-h3"
                        style={{ color: "#e6ecf1", marginBottom: "32px" }}
                      >
                        Monthly Missions
                      </h1>
                      <div
                        className="goals-overview-cards-container"
                        style={{ marginBottom: "32px" }}
                      >
                        {goalsOverview?.Q2?.months?.map((detail, index) => (
                          <GoalsOverviewBox
                            key={index}
                            title={["April", "May", "June"][index]}
                            headings={Object.entries(detail).map(
                              ([key, value]) => ({
                                title: key,
                                selected: value,
                                userGoalId:
                                  goalsOverview?.Q2?.months_user_goal_ids?.[
                                    index
                                  ]?.[key] || null,
                                time_period: "monthly",
                                month: ["April", "May", "June"][index],
                                quarter: "Q2",
                              }),
                            )}
                            onGoalClick={handleGoalClick}
                          />
                        ))}
                      </div>
                      <h1
                        className="text-heading-h3"
                        style={{ color: "#e6ecf1", marginBottom: "32px" }}
                      >
                        Quarterly Facts & Yearly Targets
                      </h1>
                      <div className="goals-overview-cards-container for-facts-and-targets">
                        {goalsOverview?.Q2?.quarterly_goals && (
                          <GoalsOverviewBox
                            title="Fact Assessments"
                            headings={Object.entries(
                              goalsOverview.Q2.quarterly_goals,
                            ).map(([key, value]) => ({
                              title: key,
                              selected: value,
                              userGoalId:
                                goalsOverview?.Q2?.quarterly_user_goal_ids?.[
                                  key
                                ] || null,
                              time_period: "quarterly",
                              quarter: "Q2",
                            }))}
                            onGoalClick={handleGoalClick}
                          />
                        )}
                        {goalsOverview?.yearly_goals && (
                          <GoalsOverviewBox
                            title="Yearly Targets"
                            headings={Object.entries(
                              goalsOverview.yearly_goals,
                            ).map(([key, value]) => ({
                              title: key,
                              selected: value,
                              userGoalId:
                                goalsOverview?.yearly_user_goal_ids?.[key] ||
                                null,
                              time_period: "yearly",
                              year: year,
                            }))}
                            onGoalClick={handleGoalClick}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div id="q3" className="tab-pane fade">
                    <div className="d-flex flex-column align-items-center">
                      <h1
                        className="text-heading-h3"
                        style={{ color: "#e6ecf1", marginBottom: "32px" }}
                      >
                        Monthly Missions
                      </h1>
                      <div
                        className="goals-overview-cards-container"
                        style={{ marginBottom: "32px" }}
                      >
                        {goalsOverview?.Q3?.months?.map((detail, index) => (
                          <GoalsOverviewBox
                            key={index}
                            title={["July", "August", "September"][index]}
                            headings={Object.entries(detail).map(
                              ([key, value]) => ({
                                title: key,
                                selected: value,
                                userGoalId:
                                  goalsOverview?.Q3?.months_user_goal_ids?.[
                                    index
                                  ]?.[key] || null,
                                time_period: "monthly",
                                month: ["July", "August", "September"][index],
                                quarter: "Q3",
                              }),
                            )}
                            onGoalClick={handleGoalClick}
                          />
                        ))}
                      </div>
                      <h1
                        className="text-heading-h3"
                        style={{ color: "#e6ecf1", marginBottom: "32px" }}
                      >
                        Quarterly Facts & Yearly Targets
                      </h1>
                      <div className="goals-overview-cards-container for-facts-and-targets">
                        {goalsOverview?.Q3?.quarterly_goals && (
                          <GoalsOverviewBox
                            title="Fact Assessments"
                            headings={Object.entries(
                              goalsOverview.Q3.quarterly_goals,
                            ).map(([key, value]) => ({
                              title: key,
                              selected: value,
                              userGoalId:
                                goalsOverview?.Q3?.quarterly_user_goal_ids?.[
                                  key
                                ] || null,
                              time_period: "quarterly",
                              quarter: "Q3",
                            }))}
                            onGoalClick={handleGoalClick}
                          />
                        )}
                        {goalsOverview?.yearly_goals && (
                          <GoalsOverviewBox
                            title="Yearly Targets"
                            headings={Object.entries(
                              goalsOverview.yearly_goals,
                            ).map(([key, value]) => ({
                              title: key,
                              selected: value,
                              userGoalId:
                                goalsOverview?.yearly_user_goal_ids?.[key] ||
                                null,
                              time_period: "yearly",
                              year: year,
                            }))}
                            onGoalClick={handleGoalClick}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div id="q4" className="tab-pane fade">
                    <div className="d-flex flex-column align-items-center">
                      <h1
                        className="text-heading-h3"
                        style={{ color: "#e6ecf1", marginBottom: "32px" }}
                      >
                        Monthly Missions
                      </h1>
                      <div
                        className="goals-overview-cards-container"
                        style={{ marginBottom: "32px" }}
                      >
                        {goalsOverview?.Q4?.months?.map((detail, index) => (
                          <GoalsOverviewBox
                            key={index}
                            title={["October", "November", "December"][index]}
                            headings={Object.entries(detail).map(
                              ([key, value]) => ({
                                title: key,
                                selected: value,
                                userGoalId:
                                  goalsOverview?.Q4?.months_user_goal_ids?.[
                                    index
                                  ]?.[key] || null,
                                time_period: "monthly",
                                month: ["October", "November", "December"][
                                  index
                                ],
                                quarter: "Q4",
                              }),
                            )}
                            onGoalClick={handleGoalClick}
                          />
                        ))}
                      </div>
                      <h1
                        className="text-heading-h3"
                        style={{ color: "#e6ecf1", marginBottom: "32px" }}
                      >
                        Quarterly Facts & Yearly Targets
                      </h1>
                      <div className="goals-overview-cards-container for-facts-and-targets">
                        {goalsOverview?.Q4?.quarterly_goals && (
                          <GoalsOverviewBox
                            title="Fact Assessments"
                            headings={Object.entries(
                              goalsOverview.Q4.quarterly_goals,
                            ).map(([key, value]) => ({
                              title: key,
                              selected: value,
                              userGoalId:
                                goalsOverview?.Q4?.quarterly_user_goal_ids?.[
                                  key
                                ] || null,
                              time_period: "quarterly",
                              quarter: "Q4",
                            }))}
                            onGoalClick={handleGoalClick}
                          />
                        )}
                        {goalsOverview?.yearly_goals && (
                          <GoalsOverviewBox
                            title="Yearly Targets"
                            headings={Object.entries(
                              goalsOverview.yearly_goals,
                            ).map(([key, value]) => ({
                              title: key,
                              selected: value,
                              userGoalId:
                                goalsOverview?.yearly_user_goal_ids?.[key] ||
                                null,
                              time_period: "yearly",
                              year: year,
                            }))}
                            onGoalClick={handleGoalClick}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Target Reflection Modal */}
      <BaseModal
        open={isModalOpen}
        onClose={handleCloseModal}
        title={`${selectedGoal?.title} - ${selectedGoal?.time_period?.charAt(0).toUpperCase() + selectedGoal?.time_period?.slice(1)} Goals`}
        width={800}
        maxHeight="600px"
      >
        {selectedGoal && (
          <TargetReflectionModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            userGoalId={selectedGoal.userGoalId}
            params={{
              time_period: selectedGoal.time_period,
              ...(selectedGoal.month && { month: selectedGoal.month }),
              ...(selectedGoal.quarter && { quarter: selectedGoal.quarter }),
              ...(selectedGoal.year && { year: selectedGoal.year }),
            }}
          />
        )}
      </BaseModal>
    </Layout>
  );
}
